import { SpsNotificationsRootController } from './sps-notifications-root.controller';
import * as template from './sps-notifications-root.html';
import * as angular from 'angular';

function SpsNotificationsRootDirective() {
    return {
        scope: {},
        restrict: 'E',
        template: template,
        controller: SpsNotificationsRootController,
        controllerAs: 'ctrl',
    };

}

export default angular
    .module('spsng.components.sps-notifications-root', [])
    .directive('spsNotificationsRoot', SpsNotificationsRootDirective)
    .name;
